import { create } from 'zustand';

const useSitePanel = create((set) => ({
  status: false,
  toggle: () => set((state) => ({ status: !state.status })),
}));

export default useSitePanel;